import api from './api';

const discoveryService = {
  // Case Contacts — rows are addressed by (contact_id, role); no link ids
  getCaseContacts: async (caseId, role = null) => {
    const params = role ? `?role=${encodeURIComponent(role)}` : '';
    const response = await api.get(`/discovery/cases/${caseId}/contacts${params}`);
    return response.data;
  },

  addCaseContact: async (caseId, contactData) => {
    const response = await api.post(`/discovery/cases/${caseId}/contacts`, contactData);
    return response.data;
  },

  removeCaseContact: async (caseId, contactId, role) => {
    const response = await api.delete(
      `/discovery/cases/${caseId}/contacts/${contactId}?role=${encodeURIComponent(role)}`
    );
    return response.data;
  },

  // Document Discovery Flag
  updateDocumentDiscoverable: async (docId, data) => {
    const response = await api.patch(`/discovery/documents/${docId}/discoverable`, data);
    return response.data;
  },

  getDiscoverableDocuments: async (caseId) => {
    const response = await api.get(`/discovery/cases/${caseId}/discoverable-documents`);
    return response.data;
  },

  // Document Exhibit Management
  updateDocumentExhibit: async (docId, data) => {
    const response = await api.patch(`/discovery/documents/${docId}/exhibit`, data);
    return response.data;
  },

  getCaseExhibits: async (caseId) => {
    const response = await api.get(`/discovery/cases/${caseId}/exhibits`);
    return response.data;
  },

  // Discovery Requests — addressed by public_id (uuid), never sequential ids
  generateDiscoveryRequest: async (caseId, data) => {
    const response = await api.post(`/discovery/cases/${caseId}/generate`, data);
    return response.data;
  },

  getDiscoveryRequests: async (caseId) => {
    const response = await api.get(`/discovery/cases/${caseId}/requests`);
    return response.data;
  },

  getDownloadAudit: async (publicId) => {
    const response = await api.get(`/discovery/requests/${publicId}/downloads`);
    return response.data;
  },

  // D1: lifecycle + audit
  revokeRequest: async (publicId) => {
    const response = await api.post(`/discovery/requests/${publicId}/revoke`);
    return response.data;
  },

  reissueRequest: async (publicId, documentIds = null) => {
    const response = await api.post(`/discovery/requests/${publicId}/reissue`,
      documentIds ? { document_ids: documentIds } : {});
    return response.data;
  },

  setRequestMode: async (publicId, mode) => {
    const response = await api.patch(`/discovery/requests/${publicId}/mode`, { mode });
    return response.data;
  },

  getAccessEvents: async (publicId) => {
    const response = await api.get(`/discovery/requests/${publicId}/events`);
    return response.data;
  },
};

export default discoveryService;
